import React from 'react';
import { Grid } from '@mui/material';

interface SettingsFieldsGridProps {
  children: React.ReactNode;
}

interface SettingsFieldProps {
  children: React.ReactNode;
  /** Full row on all breakpoints */
  fullWidth?: boolean;
}

export const SettingsFieldsGrid: React.FC<SettingsFieldsGridProps> = ({ children }) => (
  <Grid container spacing={2}>
    {children}
  </Grid>
);

export const SettingsField: React.FC<SettingsFieldProps> = ({ children, fullWidth }) => (
  <Grid size={fullWidth ? 12 : { xs: 6, sm: 4, md: 3 }}>
    {children}
  </Grid>
);
